(() => {
    const root = document.querySelector('.smart-gallery-filter');
    if (!root) return;

    const form = root.querySelector('.smart-gallery-filter__form');
    const input = root.querySelector('#smartGalleryFilterInput');
    const chips = root.querySelector('.smart-gallery-filter__chips');
    const status = root.querySelector('.smart-gallery-filter__status');
    const clearButton = root.querySelector('.smart-gallery-filter__clear');
    const sidebarPanel = document.querySelector('.all-escorts-sidebar__panel');
    const originalPosition = document.createComment('smart-gallery-filter-position');
    let smartSelections = [];

    root.parentNode.insertBefore(originalPosition, root);

    // Phones (<768px): common.js keeps the smart filter inside the Filters drawer, so
    // leave it alone there. Mobile browsers fire 'resize' when the address bar
    // shows/hides, which used to pull it back out of the drawer onto the page.
    const placeSmartFilter = () => {
        if (document.getElementById('galleryFiltersSidebar') && sidebarPanel) {
            root.classList.add('smart-gallery-filter--drawer');
            sidebarPanel.prepend(root);
            return;
        }
        if (window.matchMedia('(max-width: 767px)').matches) return;
        if (sidebarPanel && window.matchMedia('(min-width: 992px)').matches) {
            sidebarPanel.prepend(root);
        } else if (originalPosition.parentNode) {
            originalPosition.parentNode.insertBefore(root, originalPosition.nextSibling);
        }
    };

    placeSmartFilter();
    // Defer so common.js's breakpoint handler (drawer -> page) runs first when widening.
    window.addEventListener('resize', () => setTimeout(placeSmartFilter, 0));

    const normalise = (value) => String(value || '')
        .toLocaleLowerCase('en-GB')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9+]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');

    const phraseAppears = (query, phrase) => {
        if (!phrase || phrase.length < 2) return false;
        return (` ${query} `).includes(` ${phrase} `);
    };

    const candidates = async () => {
        // Filter option lists load lazily; make sure they're in the DOM before matching.
        await window.hydrateGalleryFilters?.();
        const rows = [];

        document.querySelectorAll('#fbarLocList .fbar-check-item').forEach((item) => {
            const control = item.querySelector('input.incall-location');
            const label = item.querySelector('.fbar-check-text')?.textContent.trim();
            if (control && label) rows.push({ facet: 'Location', label, phrase: normalise(label), control });
        });

        document.querySelectorAll('#fbarCatList .fbar-cat-proxy').forEach((control) => {
            const label = control.querySelector('.fbar-check-text')?.textContent.trim();
            if (label) rows.push({ facet: 'Type', label, phrase: normalise(label.replace(/\bescorts?\b/gi, '')), control });
        });

        document.querySelectorAll('#fbarSvcList .fbar-svc-proxy').forEach((control) => {
            const label = control.querySelector('.fbar-check-text')?.textContent.trim();
            if (label) rows.push({ facet: 'Service', label, phrase: normalise(label.replace(/\bescorts?\b/gi, '')), control });
        });

        document.querySelectorAll('input.hair_colour, input.nationality, input.dress, .filter-list input.category, .filter-list input.service').forEach((control) => {
            const label = control.dataset.smartLabel
                || document.querySelector(`label[for="${CSS.escape(control.id)}"]`)?.textContent.trim()
                || control.value;
            const facet = control.classList.contains('category') ? 'Type' : control.classList.contains('service') ? 'Service'
                : control.classList.contains('hair_colour') ? 'Hair' : control.classList.contains('nationality') ? 'Nationality' : 'Dress';
            rows.push({ facet, label, phrase: normalise(label), control });
        });

        const facetPriority = { Hair: 0, Location: 1, Type: 2, Service: 3, Nationality: 4, Dress: 5 };
        return rows.sort((a, b) => {
            const lengthDifference = b.phrase.length - a.phrase.length;
            if (lengthDifference) return lengthDifference;
            return (facetPriority[a.facet] ?? 99) - (facetPriority[b.facet] ?? 99);
        });
    };

    const controlIsOn = (match) => {
        if (match.control.matches('input')) return match.control.checked;
        const id = match.control.dataset.categoryId || match.control.dataset.serviceId;
        const selector = match.control.dataset.categoryId ? `input.category[value="${CSS.escape(id)}"]` : `input.service[value="${CSS.escape(id)}"]`;
        return !!document.querySelector(selector)?.checked;
    };

    const toggleMatch = (match) => {
        if (controlIsOn(match)) return false;
        if (match.control.matches('input')) {
            match.control.checked = true;
            match.control.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
            match.control.click();
        }
        return true;
    };

    const turnOff = (match) => {
        if (!match.appliedBySmart) return;
        if (!controlIsOn(match)) return;
        if (match.control.matches('input')) {
            match.control.checked = false;
            match.control.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
            match.control.click();
        }
    };

    const render = () => {
        chips.replaceChildren();
        smartSelections.forEach((match, index) => {
            const chip = document.createElement('button');
            const facet = document.createElement('span');
            const remove = document.createElement('b');
            chip.type = 'button';
            chip.className = 'smart-gallery-filter__chip';
            chip.dataset.smartIndex = String(index);
            chip.setAttribute('aria-label', `Remove ${match.label}`);
            facet.textContent = match.facet;
            remove.textContent = '×';
            remove.setAttribute('aria-hidden', 'true');
            chip.append(facet, document.createTextNode(match.label), remove);
            chips.appendChild(chip);
        });
        clearButton.hidden = smartSelections.length === 0;
    };

    const clearSmart = () => {
        smartSelections.forEach(turnOff);
        smartSelections = [];
        input.value = '';
        status.textContent = 'Smart filters cleared.';
        render();
    };

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const query = normalise(input.value);
        if (!query) {
            status.textContent = 'Describe who you’re looking for first.';
            input.focus();
            return;
        }

        try {
            if (typeof window.ensureGalleryFilterPanel === 'function') {
                await window.ensureGalleryFilterPanel();
            }
        } catch (error) {
            status.textContent = 'Some appearance filters are unavailable right now. Matching the filters already loaded.';
        }

        let options;
        try {
            options = await candidates();
        } catch (error) {
            status.textContent = 'Could not load filter options. Please try Find matches again, or use Retry in the filter.';
            return;
        }
        smartSelections.forEach(turnOff);
        smartSelections = [];
        const singleChoiceFacets = new Set(['Location', 'Hair', 'Nationality', 'Dress']);
        const claimedFacets = new Set();
        const matchedPhrases = new Set();
        options.forEach((candidate) => {
            if (matchedPhrases.has(candidate.phrase)
                || (singleChoiceFacets.has(candidate.facet) && claimedFacets.has(candidate.facet))
                || !phraseAppears(query, candidate.phrase)) return;
            matchedPhrases.add(candidate.phrase);
            if (singleChoiceFacets.has(candidate.facet)) claimedFacets.add(candidate.facet);
            smartSelections.push({
                ...candidate,
                appliedBySmart: toggleMatch(candidate),
            });
        });

        if (smartSelections.length) {
            status.textContent = `${smartSelections.length} ${smartSelections.length === 1 ? 'filter' : 'filters'} matched and applied.`;
        } else {
            status.textContent = 'We couldn’t match that yet. Try a location, type, service, or hair colour.';
        }
        render();
    });

    chips.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-smart-index]');
        if (!chip) return;
        const index = Number(chip.dataset.smartIndex);
        const match = smartSelections[index];
        if (!match) return;
        turnOff(match);
        smartSelections.splice(index, 1);
        status.textContent = `${match.label} removed.`;
        render();
    });

    clearButton.addEventListener('click', clearSmart);

    const syncWithManualFilters = () => {
        const remaining = smartSelections.filter(controlIsOn);
        if (remaining.length === smartSelections.length) return;
        smartSelections = remaining;
        render();
    };

    document.addEventListener('input', (event) => {
        if (event.target.matches('.filter-list input')) setTimeout(syncWithManualFilters, 0);
    });
    document.addEventListener('click', (event) => {
        if (event.target.closest('.clear_filter, .fbar-drawer-reset')) {
            setTimeout(() => {
                smartSelections = [];
                input.value = '';
                status.textContent = 'All filters cleared.';
                render();
            }, 0);
            return;
        }
        if (event.target.closest('.fbar-svc-proxy, .fbar-cat-proxy')) {
            setTimeout(syncWithManualFilters, 0);
        }
    });
})();